import React, { useEffect, useRef } from 'react';
import { useChatboxStateContext } from '../../context/ChatboxContext';
import { useConversationStateContext } from '../../context/ConversationContext';
import ChatBoxChat from '../ChatboxChat/ChatBoxChat';
import ChatboxFooter from '../ChatboxFooter/ChatboxFooter';
import BotService from '../../actions/ConversationAction';
import ChatboxVariablesContainer from '../ChatboxVariables/ChatboxVariablesContainer';
import ChatboxPathContainer from '../ChatboxPath/ChatboxPathContainer';
import useBlock from "/src/features/editor/hook/block/useBlock";

const ChatboxWindow = () => {
    const { valueOpen, toggleMargin } = useChatboxStateContext();
    var { mode, avatar, chatboxColor } = useConversationStateContext();
    const { getBotFirstQuestion } = BotService();
    const scrollbarRef = useRef(null);
    var className = "kwalys-chatbox-window";
    className = valueOpen ? `${className} visible` : className;
    className = toggleMargin ? `${className} margin` : className;

    useEffect(() => {
        if (scrollbarRef.current) {
            scrollbarRef.current.style.setProperty('--primary-chatbox-color', chatboxColor);
        }
    }, [chatboxColor]);

    useEffect(() => {
        getBotFirstQuestion(mode);
    }, [mode]);

    // useEffect(()=>{

    //     // return () => element.remove();
    // },[avatar])


    return (
        <div className={className} ref={scrollbarRef}>
            <ChatBoxChat mode={mode} />
            <ChatboxFooter />
            {mode == 'debug' ? <ChatboxVariablesContainer /> : null}
            {mode == 'debug' ? <ChatboxPathContainer /> : null}
        </div>
    );
};

export default ChatboxWindow;